import type { MonthlyMetrics } from "./api";

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Returns the two most recent *complete* months for comparison.
 * If the latest entry matches the current calendar month, it's treated
 * as a partial month and skipped — we compare the two months before it.
 */
export function getCompletedMonthsForComparison(
  monthlySavings: MonthlyMetrics[],
) {
  if (monthlySavings.length < 2) return { current: null, previous: null };

  const now = new Date();
  const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

  const latest = monthlySavings[monthlySavings.length - 1];
  const isPartialMonth = latest.month === currentYearMonth;

  if (isPartialMonth) {
    // Skip the partial month — compare the two before it
    if (monthlySavings.length < 3) return { current: null, previous: null };
    return {
      current: monthlySavings[monthlySavings.length - 2],
      previous: monthlySavings[monthlySavings.length - 3],
    };
  }

  return {
    current: monthlySavings[monthlySavings.length - 1],
    previous: monthlySavings[monthlySavings.length - 2],
  };
}
